import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsRevenueByDateQuery } from "../graphql/queries";
import type {
  AnalyticsRevenueByDateQueryType,
  AnalyticsRevenueByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsRevenueByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsRevenueByDateQueryType,
    AnalyticsRevenueByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsRevenueByDateQueryType,
    AnalyticsRevenueByDateQueryVariablesType
  >(AnalyticsRevenueByDateQuery, options);
};
